import { render } from "./RemoveUser.vue?vue&type=template&id=85c86a2a&scoped=true"
import script from "./RemoveUser.vue?vue&type=script&lang=js"
export * from "./RemoveUser.vue?vue&type=script&lang=js"

import "./RemoveUser.vue?vue&type=style&index=0&id=85c86a2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c86a2a"]])

export default __exports__